import { FC } from 'react';

interface StreamingIndicatorProps {
  text?: string;
}

const StreamingIndicator: FC<StreamingIndicatorProps> = ({ text = 'Thinking' }) => {
  return (
    <div className="flex items-center space-x-2.5 text-gray-500 dark:text-gray-400 text-sm">
      <span className="font-medium">{text}</span>
      <div className="flex space-x-1">
        <span
          className="w-2 h-2 bg-orange dark:bg-teal-400 rounded-full animate-bounce opacity-80"
          style={{ animationDelay: '0ms' }}
        />
        <span
          className="w-2 h-2 bg-orange dark:bg-teal-400 rounded-full animate-bounce opacity-80"
          style={{ animationDelay: '150ms' }}
        />
        <span
          className="w-2 h-2 bg-orange dark:bg-teal-400 rounded-full animate-bounce opacity-80"
          style={{ animationDelay: '300ms' }}
        />
      </div>
    </div>
  );
};

export default StreamingIndicator;
